export const cashRegisters = {
  "cashRegister.settingsSync": "Синхронизация настроек",
  "cashRegister.settingsCurrent": "Текущие настройки подтверждены",
  "cashRegister.settingsPending": "Ожидается подтверждение текущих настроек",
  "cashRegister.settingsSent": "Настройки отправлены",
  "cashRegister.settingsAcknowledged": "Сохранение настроек подтверждено",
  "cashRegister.firmware": "Прошивка",
  "cashRegister.registrationNumber": "Регистрационный номер",
  "cashRegister.deviceMode": "Режим устройства",
  "cashRegister.cashBalance": "Наличность в кассе",
  "cashRegister.ofdPending": "Документов в очереди ОФД",
  "cashRegister.ofdOldest": "Самый старый документ в очереди ОФД",
  "cashRegister.lastDocument": "Последний документ кассы",
  "cashRegister.lastDocumentAt": "Время последнего документа кассы",
  "cashRegister.savedRequest": "Сохранённый запрос в кассу",
  "cashRegister.savedRequestHint": "Это сохранённый запрос, отправленный в кассу. Фискальные реквизиты ниже прочитаны из кассы; это не полная копия напечатанного чека.",
  "cashRegister.issuerTaxId": "ИНН организации",
  "cashRegister.cashier": "Кассир",
  "cashRegister.cashierTaxId": "ИНН кассира",
  "cashRegister.unsupportedClinic": "Для вашей клиники кассы пока недоступны.",
  "cashRegister.alreadyFiscalized": "Для этой финансовой операции уже есть фискальный документ. Посмотрите журнал кассы.",
  "cashRegister.sourceMismatch": "Оплата или возврат относятся к другому филиалу, юрлицу или валюте. Выберите соответствующую кассу.",
  "cashRegister.pairingThrottled": "Код выдан менее минуты назад. Запросите следующий через минуту.",
  "cashRegister.transferRequired": "Касса уже привязана. Для другого рабочего места сначала перенесите её в карточке кассы.",
  "cashRegister.unresolved": "Операция или печать документа не завершены. Разрешите их в журнале и компоненте в трее.",
  "cashRegister.evidenceConflict": "Реквизиты документа противоречат операции или другому сохранённому документу. Сверьте исходные фискальные данные.",
  "cashRegister.noEffect": "Отсутствие документа не доказывает отсутствие фискальной операции. Для разрешения результата нужны данные кассы.",
  "cashRegister.alreadyResolved": "Эта операция больше не требует сверки. Обновите запись в журнале.",
  "cashRegister.deviceAssigned": "Это устройство уже привязано. Перенесите его текущую кассу перед новой привязкой.",
  "cashRegister.notReady": "Оборудование не готово. Проверьте драйвер, связь и фискальное состояние.",
  "cashRegister.shiftRequired": "Для операции нужна открытая непросроченная смена.",
  "cashRegister.codeInvalid": "Код неверен, истёк или уже использован. Получите новый в карточке кассы.",
  "cashRegister.versionUnsupported": "Протокол локального компонента несовместим. Установите опубликованную версию компонента.",
  "cashRegister.pending": "Отправка…",
  "cashRegister.createHolding": "Введите название кассы и выберите филиал.",
  "cashRegister.vat.none": "Без НДС",
  "cashRegister.vat.vat0": "0%",
  "cashRegister.vat.vat5": "5%",
  "cashRegister.vat.vat7": "7%",
  "cashRegister.vat.vat10": "10%",
  "cashRegister.vat.vat20": "20%",
  "cashRegister.vat.vat22": "22%",
  "cashRegister.vat.vat105": "5/105",
  "cashRegister.vat.vat107": "7/107",
  "cashRegister.vat.vat110": "10/110",
  "cashRegister.vat.vat120": "20/120",
  "cashRegister.vat.vat122": "22/122",
  "cashRegister.server": "HTTPS-адрес системы",
  "cashRegister.title": "Кассы",
  "cashRegister.description": "Оборудование, рабочие места, смены и фискальные документы",
  "cashRegister.deviceError": "Ошибка устройства",
  "cashRegister.noDeviceError": "Ошибка не передана",
  "cashRegister.model": "Модель кассы",
  "cashRegister.name": "Название кассы",
  "cashRegister.itemName": "Наименование",
  "cashRegister.branch": "Филиал",
  "cashRegister.taxSystem": "Система налогообложения",
  "cashRegister.create": "Создать кассу",
  "cashRegister.save": "Сохранить",
  "cashRegister.cancel": "Отмена",
  "cashRegister.loading": "Загрузка касс…",
  "cashRegister.empty": "Касс пока нет",
  "cashRegister.failed": "Не удалось выполнить действие с кассой. Обновите состояние и проверьте связь и сведения об операции.",
  "cashRegister.forbidden": "У вас нет прав на это действие.",
  "cashRegister.conflict": "Касса отклонила операцию. Проверьте её состояние и журнал.",
  "cashRegister.itemsUnsupported": "Сохранённые финансовые сведения не позволяют составить поддерживаемый чек. Проверьте позиции услуг, распределение оплаты, явную ставку налога и исходный чек для возврата.",
  "cashRegister.unsaved": "Настройки кассы не сохранены.",
  "cashRegister.state": "Состояние",
  "cashRegister.shift": "Смена",
  "cashRegister.connection": "Связь",
  "cashRegister.install": "Установочный диск",
  "cashRegister.openShift": "Открыть смену",
  "cashRegister.closeShift": "Закрыть смену",
  "cashRegister.journal": "Журнал операций",
  "cashRegister.kind": "Операция",
  "cashRegister.amount": "Сумма",
  "cashRegister.created": "Создано",
  "cashRegister.print": "Печать",
  "cashRegister.document": "Фискальный документ",
  "cashRegister.refresh": "Обновить",
  "cashRegister.more": "Загрузить ещё",
  "cashRegister.noBinding": "Не привязана",
  "cashRegister.stale": "Сведения устарели",
  "cashRegister.agent": "Локальный компонент",
  "cashRegister.driver": "Драйвер",
  "cashRegister.device": "Устройство",
  "cashRegister.fiscal": "Фискальная готовность",
  "cashRegister.paper": "Бумага",
  "cashRegister.ofd": "Обмен с ОФД",
  "cashRegister.observed": "Последняя проверка",
  "cashRegister.machine": "Рабочее место",
  "cashRegister.serial": "Серийный номер кассы",
  "cashRegister.storage": "Серийный номер ФН",
  "cashRegister.reason": "Причина",
  "cashRegister.rename": "Переименовать",
  "cashRegister.transfer": "Перенести на другое рабочее место",
  "cashRegister.archive": "Архивировать кассу",
  "cashRegister.drainHint": "Неопределённые операции и незавершённая печать блокируют перенос. Сначала завершите сверку, затем повторите перенос.",
  "cashRegister.installSteps": "Установите компонент Windows, откройте его из трея и вставьте код привязки с этой страницы. Оборудование настройте в тесте драйвера производителя. После привязки здесь появятся сведения от компонента.",
  "cashRegister.install.getComponent": "Скачайте компонент",
  "cashRegister.install.runInstaller": "Установите его на рабочем месте",
  "cashRegister.install.connect": "Свяжите рабочее место с системой",
  "cashRegister.install.verify": "Проверьте оборудование",
  "cashRegister.install.version": "Версия компонента",
  "cashRegister.install.size": "Размер установщика",
  "cashRegister.install.checksum": "SHA-256 установщика",
  "cashRegister.install.distributionFailed": "Не удалось получить опубликованный компонент. Повторите запрос — на саму кассу это не влияет.",
  "cashRegister.country": "Профиль страны",
  "cashRegister.countryLimited": "Кассовое оборудование пока поддерживает российские фискальные правила RU/RUB.",
  "cashRegister.unsigned": "Установщик без цифровой подписи. Windows может предупредить об издателе или заблокировать запуск по политике компьютера. HTTPS и манифест SHA-256 защищают целостность загрузки.",
  "cashRegister.download": "Скачать установщик Windows",
  "cashRegister.manifest": "Скачать манифест SHA-256",
  "cashRegister.vendor.atol": "АТОЛ DTO 10",
  "cashRegister.vendor.shtrih": "Штрих",
  "cashRegister.vendor": "Установить драйвер производителя x86 отдельно",
  "cashRegister.pair": "Получить код привязки",
  "cashRegister.code": "Код привязки",
  "cashRegister.expires": "Действует до",
  "cashRegister.codeHint": "Скопируйте код привязки целиком в локальный модуль. Он содержит адрес сервера, действует один раз и истекает через десять минут.",
  "cashRegister.preview": "Проверить состав чека",
  "cashRegister.queue": "Отправить на кассу",
  "cashRegister.receiptAction": "Выдать кассовый чек",
  "cashRegister.refundAction": "Выдать кассовый возврат",
  "cashRegister.sourceHint": "Действие фискализирует сохранённую финансовую операцию. Повторная оплата или выплата не создаётся.",
  "cashRegister.queued": "Операция сохранена. Проверьте итоговый результат в журнале кассы.",
  "cashRegister.events": "События операции",
  "cashRegister.evidence": "Ссылка на подтверждение",
  "cashRegister.reconcile": "Сверить по фискальному документу",
  "cashRegister.reconcileHint": "Укажите реквизиты фактического документа кассы. Отсутствие чека само по себе не разрешает повторную операцию. Допечатка выполняется в трее только для этого существующего документа.",
  "cashRegister.number": "Номер документа",
  "cashRegister.fiscalSign": "Фискальный признак",
  "cashRegister.issuedAt": "Время документа кассы (ISO 8601 с часовым поясом)",
  "cashRegister.shiftNumber": "Номер смены",
  "cashRegister.back": "К кассе",
  "cashRegister.quantity": "Количество",
  "cashRegister.vat": "НДС",
  "cashRegister.signal.ready": "Готово",
  "cashRegister.signal.unknown": "Неизвестно",
  "cashRegister.signal.unavailable": "Недоступно",
  "cashRegister.signal.unsupported": "Не поддерживается",
  "cashRegister.shift.open": "Открыта",
  "cashRegister.shift.closed": "Закрыта",
  "cashRegister.shift.expired": "Истекла",
  "cashRegister.shift.unknown": "Неизвестно",
  "cashRegister.lifecycle.active": "Действующая",
  "cashRegister.lifecycle.draining": "Завершение принятых операций",
  "cashRegister.lifecycle.archived": "В архиве",
  "cashRegister.kind.open_shift": "Открытие смены",
  "cashRegister.kind.close_shift": "Закрытие смены",
  "cashRegister.kind.sale": "Чек прихода",
  "cashRegister.kind.refund": "Чек возврата",
  "cashRegister.kind.recover": "Восстановление",
  "cashRegister.state.queued": "В очереди",
  "cashRegister.state.prepared": "Подготовлена",
  "cashRegister.state.executing": "Выполнение разрешено",
  "cashRegister.state.succeeded": "Фискальный результат подтверждён",
  "cashRegister.state.failed": "Отказ до фискальной операции",
  "cashRegister.state.outcome_unknown": "Результат неизвестен — сначала сверка",
  "cashRegister.state.cancelled": "Отменена до выполнения",
  "cashRegister.print.unknown": "Неизвестно",
  "cashRegister.print.not_required": "Не требуется",
  "cashRegister.print.printed": "Напечатано",
  "cashRegister.print.pending": "Фискализировано; печать не завершена",
  "cashRegister.taxSystem.osn": "ОСН",
  "cashRegister.taxSystem.usn_income": "УСН: доходы",
  "cashRegister.taxSystem.usn_income_outcome": "УСН: доходы минус расходы",
  "cashRegister.taxSystem.esn": "ЕСХН",
  "cashRegister.taxSystem.patent": "Патент",
} as const
